<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 19C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H21ZM21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H9C8.44772 17 8 16.5523 8 16C8 15.4477 8.44772 15 9 15H21ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21ZM21 7C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7H21ZM21 3C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5H3C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H21Z"
    fill="currentColor"
  />
</svg>
